import React from "react";
import { Skeleton } from "@mui/material";

type customSkeletonProps = {
  numberOfRows: number;
  width: number | string;
  height: number | string;
};

const CustomSkeleton = (props: customSkeletonProps) => {
  const { numberOfRows = 1, width = 100, height = 100 } = props;
  const array = Array.from({ length: numberOfRows }, (_, i) => i + 1);

  return (
    <>
      {array?.map((item) => {
        return (
          <Skeleton
            key={item}
            sx={{
              my: 1,
            }}
            animation="wave"
            variant="rectangular"
            width={width}
            height={height}
          />
        );
      })}
    </>
  );
};

export default CustomSkeleton;
